import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Group } from '../components/Group';
const Item = (props) => {
    if (props.children) {
        return _jsx("div", { style: { border: '2px solid #aaaaaa',
                borderRadius: '6px',
                padding: '5px 7px 2px 7px',
                marginLeft: '8px',
                marginBottom: '4px',
                backgroundColor: '#ffffff'
            }, children: props.children });
    }
    else
        return null;
};
export const ZigbeeNodeDescriptor = (props) => {
    const node_descriptor = props.node_descriptor;
    if (node_descriptor == null) {
        return (_jsx(Group, { title: "Node Descriptor", children: _jsx("form", { onSubmit: props.onFetchNodeDescriptor, style: { padding: '10px 10px' }, children: _jsx("button", { type: "submit", children: "Fetch" }) }) }));
    }
    let logical_type;
    switch (node_descriptor.logical_type) {
        case 'coordinator':
            logical_type = 'Coordinator';
            break;
        case 'router':
            logical_type = 'Router';
            break;
        case 'end device':
            logical_type = 'End Device';
            break;
        default:
            logical_type = '???';
            break;
    }
    const freq868 = node_descriptor.frequency_band_868 ? '868MHz' : null;
    const freq902 = node_descriptor.frequency_band_902 ? '902MHz' : null;
    const freq2400 = node_descriptor.frequency_band_2400 ? '2.4GHz' : null;
    const power = node_descriptor.power_source_mains ? 'Mains power' : 'Other power';
    const dtype = node_descriptor.device_type_full ? 'Full function device' : 'Reduced function device';
    const idle = node_descriptor.reciever_on_when_idle ? 'On when idle' : 'Off when idle';
    const ndesc = null; // <pre>{JSON.stringify(node_descriptor, null, 4)}</pre>
    return (_jsxs(Group, { title: "Node Descriptor", children: [_jsxs("div", { style: { display: 'flex', flexWrap: 'wrap', alignContent: 'space-around' }, children: [_jsx(Item, { children: logical_type }), _jsx(Item, { children: freq868 }), _jsx(Item, { children: freq902 }), _jsx(Item, { children: freq2400 }), _jsx(Item, { children: power }), _jsx(Item, { children: dtype }), _jsx(Item, { children: idle }), _jsx(Item, { children: node_descriptor.manufacturer_name })] }), ndesc, _jsx("form", { onSubmit: props.onFetchNodeDescriptor, style: { padding: '10px 10px' }, children: _jsx("button", { type: "submit", children: "Fetch" }) })] }));
};
